/* eslint-disable func-names */
import Siema from 'siema';
import '../polyfills/closest';

// sliders
const videoSliders = [...document.querySelectorAll('.js-videoSlider')];

const domparser = new DOMParser();

if (videoSliders.length) {
  videoSliders.forEach(function applySlider(videoSlider) {
    const slides = [...videoSlider.querySelectorAll('.js-videoSlide')];

    const videoWrapper = videoSlider
      .closest('.js-videoSliderParent')
      .querySelector('.js-videoSliderVideoWrapper');

    const buttonPrev = videoSlider
      .closest('.js-videoSliderParent')
      .querySelector('.js-videoSliderNavPrev');

    const buttonNext = videoSlider
      .closest('.js-videoSliderParent')
      .querySelector('.js-videoSliderNavNext');

    let buttonNavs = [
      ...videoSlider
        .closest('.js-videoSliderParent')
        .querySelectorAll('.js-videoSliderNavButton'),
    ];

    const slider = new Siema({
      selector: videoSlider,
      duration: 0,
      easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
      loop: true,
      onChange() {
        const currentSlideElement = slides[slider.currentSlide];
        const slideVideo = currentSlideElement.dataset.associatedVideo;
        const newVideo = domparser.parseFromString(
          `
                <div class="videoSlider__videoWrapper js-videoSliderVideo">${slideVideo}</div>
          `,
          'text/html'
        );

        slides.forEach(slide => {
          slide.classList.remove('-active');
        });

        buttonNavs.forEach(buttonNav => {
          buttonNav.classList.remove('-active');
        });

        buttonNavs[slider.currentSlide].classList.add('-active');
        slides[slider.currentSlide].classList.add('-active');

        // eslint-disable-next-line prefer-const
        let video = videoSlider
          .closest('.js-videoSliderParent')
          .querySelector('.js-videoSliderVideo');

        videoWrapper.appendChild(newVideo.querySelector('.js-videoSliderVideo'));

        setTimeout(() => {
          video.remove();
        }, 1000);
      },
    });

    if (buttonPrev) {
      buttonPrev.addEventListener('click', () => {
        slider.prev(1);
      });
    }

    if (buttonNext) {
      buttonNext.addEventListener('click', () => {
        slider.next(1);
      });
    }

    buttonNavs.forEach(buttonNav => {
      buttonNav.addEventListener('click', () => {
        const navIndex = buttonNav.dataset.index * 1;

        slider.goTo(navIndex);
      });
    });
  });
}
